import { motion } from "framer-motion";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";

export const FinalCTA = () => (
  <section
    className="relative flex flex-col items-center px-5 py-24 text-center sm:px-8 sm:py-28"
    data-testid="final-cta-section"
  >
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="font-display max-w-md text-2xl font-extrabold text-white sm:text-3xl"
    >
      Don&rsquo;t find out last.
    </motion.h2>
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="mt-3 max-w-sm text-sm text-white/55 sm:text-base"
    >
      Tap in, and be part of the room when the big reveal drops around Teacher&rsquo;s Day.
    </motion.p>

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="mt-8 w-full max-w-sm sm:max-w-none"
    >
      <CTAButton label="Click Here to Join WhatsApp Community" testId="final-cta-whatsapp" size="large" />
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.3 }}
      className="mt-9"
    >
      <Countdown testId="final-countdown" />
    </motion.div>

    <p className="mt-10 text-[11px] uppercase tracking-[0.2em] text-white/25">
      MIK Education &mdash; First Access
    </p>
  </section>
);
